<template>
  <div id="products">
    <h2 class="p-mt-2 p-mx-2">Products</h2>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Beschreibung</th>
          <th>Lieferung (KW)</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="product in allProducts" :key="product.id">
          <td scope="row">{{ product.id }}</td>
          <td>{{ product.name }}</td>
          <td>{{ product.description }}</td>
          <td>{{ product.deliveryDate }}</td>
          <td>{{ product.price }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { FETCH_PRODUCTS } from "../../store/actions.type";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { mapGetters } from "vuex";

export default {
  name: "Products",
  data() {
    return {
      suppliers: [],
    };
  },
  mounted() {},
  methods: {
    fetchProducs() {
      this.$store.dispatch(FETCH_PRODUCTS);
    },
  },
  created() {
    if (!this.$msal.isAuthenticated()) {
      this.$router.push("/login");
    }

    if (this.$msal.isAuthenticated()) {
      this.fetchProducs();
    }
  },
  computed: {
    ...mapGetters(["allProducts"]),
  },
  watch: {
    allSuppliers(suppliers) {},
  },
  components: {
    DataTable,
    Column,
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/view/pages/Products.vue